module.exports = __webpack_public_path__ + "img/IMG_9257_T_L.0edfa1e5.webp";